import { ILesson } from '@dtos/Course'
import { create, StateCreator } from 'zustand'

interface ICurrentLessonState {
  currentLesson: ILesson | null
  setCurrentLesson: (lesson: ILesson) => void
}

const createCurrentLessonStore: StateCreator<ICurrentLessonState> = (set) => ({
  currentLesson: null,
  setCurrentLesson: (lesson: ILesson) => set({ currentLesson: lesson }),
})

export const useCurrentLessonStore = create<ICurrentLessonState>(
  createCurrentLessonStore,
)
